import React from 'react';
export function Footer() {
  const links = ['Aviso Legal', 'Privacidad', 'Cookies', 'Reembolso', 'Contacto'];
  return <footer className="bg-white border-t border-brand-border py-10 px-4 text-center" data-id="element-90" data-mp="3ggapns7ja73v">
      <div className="max-w-3xl mx-auto" data-id="element-91" data-mp="32onk11rpbm8f">
        <div className="font-display italic text-brand-primary font-bold text-lg mb-4 tracking-wide" data-id="element-92" data-mp="32pp3nums9h1r">
          RETO NUTRICIONAL™
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-6 text-sm font-body text-brand-textMuted" data-id="element-93" data-mp="3ueilfwsu32dg">
          {links.map((link, i) => <a key={i} href="#" className="hover:text-brand-primary transition-colors" data-id="element-94" data-mp="37xv6falryhh" data-mpi={i}>
              {link}
            </a>)}
        </div>

        <div className="font-body text-xs text-brand-textMuted leading-relaxed max-w-2xl mx-auto" data-id="element-95" data-mp="3qd6u9muba935">
          © 2025 Reto Nutricional. Todos los derechos reservados. Sistema
          Mimetismo Nutricional™ es un programa educativo de nutrición y
          bienestar. No constituye consejo médico ni diagnóstico. Consulta
          con tu médico antes de realizar cambios significativos en tu
          alimentación.
        </div>
      </div>
    </footer>;
}